namespace Vit.Reports {
    export class ReportBase<T> {

        public static Current: ReportBase<any>;
        reportFilterForm: ReportFilterForm;
        reportId: string;
        report: Stimulsoft.Report.StiReport;
        element: string;
        rightToLeft: boolean;
        dataSources: any;

        static dateFormat = "yyyy/MM/dd";

        static dateTimeFormat = "yyyy/MM/dd hh:mm";


        static isInitialized: boolean = false;
        protected initialize() {
            if (ReportBase.isInitialized)
                return;
            ReportBase.isInitialized = true;
            (<any>Date.prototype).orig_toString = Date.prototype.toString;


            Stimulsoft.Report.Dictionary.StiFunctions.addFunction("dateformat", "dateformat", "dateformat", "", "", String, "", [Date], ["date"], [""], (date) => {
                if (date.innerDate)
                    return Serenity.DateFormatter.format(date.innerDate, ReportBase.dateFormat);
                return Serenity.DateFormatter.format(date, ReportBase.dateFormat);
            });

            Stimulsoft.Report.Dictionary.StiFunctions.addFunction("datetimeformat", "datetimeformat", "datetimeformat", "", "", String, "", [Date], ["date"], [""], (date) => {
                if (date.innerDate)
                    return Serenity.DateFormatter.format(date.innerDate, ReportBase.dateTimeFormat);
                return Serenity.DateFormatter.format(date, ReportBase.dateTimeFormat);
            });
        }

        public renderReport(reportId: string, element: string, language: string, dataSources?: any) {
            this.rightToLeft = language == 'fa' || language == 'ar';
            this.initialize();
            this.reportId = reportId;
            this.element = element;
            this.dataSources = dataSources;

            Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7koivWV0htru4Pn2682yhdY3+9jxMCVTKcKAjiEjgJzqXgLFCpe62hxJ7/VJZ9Hq5l39md0pyydqd5Dc1fSWhCtYqC042BVmGNkukYJQN0ufCozjA/qsNxzNMyEql26oHE6wWE77pHutroj+tKfOO1skJ52cbZklqPm8OiH/9mfU4rrkLffOhDQFnIxxhzhr2BL5pDFFCZ7axXX12y/4qzn5QLPBn1AVLo3NVrSmJB2KiwGwR4RL4RsYVxGScsYoCZbwqK2YrdbPHP0t5vOiLjBQ+Oy6F4rNtDYHn7SNMpthfkYiRoOibqDkPaX+RyCany0Z+uz8bzAg0oprJEn6qpkQ56WMEppdMJ9/CBnEbTFwn1s/9s8kYsmXCvtI4iQcz+RkUWspLcBzlmj0lJXWjTKMRZz+e9PmY11Au16wOnBU3NHvRc9T/Zk0YFh439GKd/fRwQrk8nJevYU65ENdAOqiP5po7Vnhif5FCiHRpxgF";
            var localization = Vit.Reports.Localization[language];
            if (localization)
                Stimulsoft.Base.Localization.StiLocalization.setLocalization(localization);



            var reportFilterFormKey = this.getReportFilterFormKey();
            if (reportFilterFormKey) {
                var reportFilterForm = Q.ScriptData.reload(`Form.${reportFilterFormKey}`);

                if (reportFilterForm) {
                    this.reportFilterForm = new ReportFilterForm();

                    this.reportFilterForm.element.removeClass('hidden').appendTo("#reportFilterDiv");
                    (<any>this.reportFilterForm).arrange();
                }
            }

            this.showReport();
        }
        public showReport() {
            if (this.reportFilterForm) {
                if (!this.validateFormData())
                    return;
            }
            this.reportId = this.getReportId();

            this.report = new Stimulsoft.Report.StiReport();
            this.report.loadFile(`/Reports/Definition/${this.reportId}`);
            if (this.report.pages.length == 0) {
                alert("Invalid Report!");
                return;
            }

            var l = this.report.dictionary.databases.list.length;
            for (var i = 0; i < l; i++) {
                var db: any = this.report.dictionary.databases.list[i];
                db.pathData = "";
            }

            var jsonData = this.getData(this.report);

            var dataSet = new Stimulsoft.System.Data.DataSet("Data");
            dataSet.readJson(jsonData);
            this.report.regData(dataSet.dataSetName, "", dataSet);
            ReportManager.showReport(this.report, this.element, this.rightToLeft);
        }
        validateFormData(): boolean {
            return true;
        }
        getFormData(): T {
            return <T>this.reportFilterForm.getFormData();
        }

        public getReportFilterFormKey() {
            return this.reportId;
        }

        protected getReportId(): string {
            return this.reportId;
        }
        protected getData(report: Stimulsoft.Report.StiReport): any {
            var jsonData = {};
            for (var item of report.dataSources.list) {
                var defaultUrl = null;
                if (item.alias.substr(0, 1) == '~')
                    defaultUrl = item.alias.substr(1);

                if (this.dataSources && this.dataSources[item.name])
                    jsonData[item.name] = this.dataSources[item.name];
                else
                    jsonData[item.name] = this.getDataSource(item.name, defaultUrl) || [];
            }
            return jsonData;
        }
        protected getDataSource(dataSourceName: string, defaultUrl: string) {
            var data = null;
            var dataSourceOptions = this.getDataSourceOptions(dataSourceName, defaultUrl);
            if (dataSourceOptions != null && dataSourceOptions.url != null) {
                (<JQueryAjaxSettings>dataSourceOptions).async = false;
                (<JQueryAjaxSettings>dataSourceOptions).complete = (responce, status) => {
                    data = responce.responseJSON.Entities;
                };
                (<JQueryAjaxSettings>dataSourceOptions).error = (response, err) => {
                }
                $.ajax(dataSourceOptions);
            }
            return data;
        }
        protected getDataSourceOptions(dataSourceName: string, defaultUrl: string): IDataSourceOption {
            return {
                contentType: "application/json",
                url: defaultUrl,
                method: "post",
                data: JSON.stringify(this.getDataSourceRequestData(dataSourceName)),
            };
        }
        protected getDataSourceRequestData(dataSourceName: string): Serenity.ListRequest {
            var requestData: Serenity.ListRequest =
            {
                IncludeColumns: [],
                IncludeDeleted: false,
                Sort: [],
                Take: 100,
                Skip: 0,
            };

            var i = 0;
            this.report.dataSources.list.forEach(ds => {
                if (ds.name == dataSourceName) {
                    ds.columns.list.forEach(c => {
                        requestData.IncludeColumns.add(c.name);
                        if (i == 0)
                            requestData.Sort.add(c.name);
                        i++;
                    });
                }
            });
            return requestData;
        }
    }

    export class ReportFilterForm extends Serenity.EntityDialog<any, any> {
        constructor() {
            super()
        }
        protected getFormKey() {
            return ReportBase.Current.getReportFilterFormKey();
        }
        //protected getTemplateName(): string {
        //    return "EntityDialog";
        //}

        protected getToolbarButtons() {
            var list: Serenity.ToolButton[] = [];
            list.push({
                title: "نمایش گزارش",//Q.text("Controls.EntityDialog.SaveButton"),
                cssClass: "show-report-button",
                icon: "fa-show-report-o text-purple",
                hotkey: "alt+s",
                onClick: () => {
                    ReportBase.Current.showReport();
                },
                visible: () => !this.isDeleted() && !this.isViewMode(),
                disabled: () => !this.hasSavePermission() || this.readOnly,
            });

            return list;
        }
        public getFormData(): any {
            var formData = {};
            var editors = this.propertyGrid.get_editors();
            var items = this.propertyGrid.get_items();
            for (var i in items) {
                formData[items[i].name] = (<any>editors[i]);
            }
            return formData;
        }
    }
}